module.exports = __webpack_public_path__ + "img/MarkerVaste.44d50a65.svg";